// Maps catalog service names to their root domain for Clearbit logo lookup.
// Usage: https://logo.clearbit.com/${LOGOS["Netflix"]}
const LOGOS = {
  // Streaming
  "Netflix": "netflix.com",
  "Disney+": "disneyplus.com",
  "Hulu": "hulu.com",
  "Max (HBO)": "max.com",
  "Apple TV+": "apple.com",
  "Amazon Prime Video": "primevideo.com",
  "Peacock": "peacocktv.com",
  "Paramount+": "paramountplus.com",
  "ESPN+": "espnplus.com",
  "YouTube Premium": "youtube.com",
  "Fubo TV": "fubo.tv",
  "Crunchyroll": "crunchyroll.com",
  "NBA League Pass": "nba.com",
  "MLB.TV": "mlb.com",
  "Mubi": "mubi.com",

  // Music & Audio
  "Spotify": "spotify.com",
  "Apple Music": "apple.com",
  "YouTube Music": "music.youtube.com",
  "Tidal": "tidal.com",
  "Audible": "audible.com",
  "SiriusXM": "siriusxm.com",
  "Pandora Plus": "pandora.com",
  "Kindle Unlimited": "amazon.com",

  // AI Tools
  "ChatGPT Plus": "openai.com",
  "Claude Pro": "anthropic.com",
  "Microsoft Copilot Pro": "microsoft.com",
  "Gemini Advanced": "google.com",
  "Midjourney": "midjourney.com",
  "Perplexity Pro": "perplexity.ai",
  "Grammarly Premium": "grammarly.com",
  "Notion AI": "notion.so",
  "Jasper": "jasper.ai",
  "ElevenLabs": "elevenlabs.io",
  "GitHub Copilot": "github.com",
  "Cursor": "cursor.com",

  // Social & Creator
  "X Premium (Twitter)": "x.com",
  "Snapchat+": "snapchat.com",
  "LinkedIn Premium": "linkedin.com",
  "Discord Nitro": "discord.com",
  "Patreon": "patreon.com",
  "Meta Verified": "meta.com",
  "Substack": "substack.com",
  "Beehiiv": "beehiiv.com",

  // Shopping & Delivery
  "Amazon Prime": "amazon.com",
  "Walmart+": "walmart.com",
  "DoorDash DashPass": "doordash.com",
  "Uber One": "uber.com",
  "Instacart+": "instacart.com",
  "Shipt": "shipt.com",
  "HelloFresh": "hellofresh.com",
  "Costco Membership": "costco.com",
  "Sam's Club": "samsclub.com",

  // Health & Fitness
  "Peloton App": "onepeloton.com",
  "Planet Fitness": "planetfitness.com",
  "LA Fitness": "lafitness.com",
  "Equinox": "equinox.com",
  "MyFitnessPal Premium": "myfitnesspal.com",
  "Calm": "calm.com",
  "Headspace": "headspace.com",
  "Noom": "noom.com",
  "Strava": "strava.com",

  // Learning & Language
  "Duolingo Plus": "duolingo.com",
  "Pimsleur": "pimsleur.com",
  "Rosetta Stone": "rosettastone.com",
  "Babbel": "babbel.com",
  "Masterclass": "masterclass.com",
  "Coursera Plus": "coursera.org",
  "LinkedIn Learning": "linkedin.com",
  "Skillshare": "skillshare.com",

  // Cloud & Productivity
  "iCloud+": "apple.com",
  "Google One": "one.google.com",
  "Microsoft 365": "microsoft.com",
  "Dropbox Plus": "dropbox.com",
  "Adobe Creative Cloud": "adobe.com",
  "Figma": "figma.com",
  "Canva Pro": "canva.com",
  "Slack Pro": "slack.com",
  "Zoom Pro": "zoom.us",
  "1Password": "1password.com",
  "LastPass": "lastpass.com",
  "NordVPN": "nordvpn.com",
  "ExpressVPN": "expressvpn.com",
  "Surfshark": "surfshark.com",
};

export function getLogoUrl(serviceName) {
  const domain = LOGOS[serviceName];
  return domain ? `https://www.google.com/s2/favicons?domain=${domain}&sz=128` : null;
}
